import { DatePipe } from '@angular/common';
import { Directive } from '@angular/core';
import { ColumnDefinition } from '../advanced-gridview/models/column-definition';
import { ColumnListDefinition } from '../advanced-gridview/models/column-list-definition';
import { ColumnType } from '../advanced-gridview/models/column-type';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'base',
    standalone: true,
})
export class BaseDirective {
    /**
     * Constructeur.
     * @param datePipe : Pipe Date utilisé pour formatter les dates.
     */
    constructor(protected datePipe: DatePipe) {}

    /**
     * Retourne le moteur de rendu de la cellule correspondant à la propriété spécifiée.
     * @param propertyCode : Code de la propriété.
     * @returns: le moteur de rendu.
     */
    public getCellRenderer(columnDefinition: ColumnDefinition) {
        const cell = (row: any) => {
            return this.formatDefaultData(columnDefinition, row);
        };
        return cell;
    }

    /**
     * Formatte la donnée d'une cellule de la liste des dossiers (mode par défaut).
     * @param columnDefinition : Definition de la colonne auquelle appartient la cellule.
     * @param row : Donnée métier associée à la ligne auquelle appartient la cellule.
     * @returns La donnée formattée.
     */
    private formatDefaultData(columnDefinition: ColumnDefinition, row: object): string {
        if (columnDefinition.type === ColumnType.List) {
            if (row[columnDefinition.columnName]) {
                return `${(columnDefinition as ColumnListDefinition<string>).dataSource[row[columnDefinition.columnName]]}`;
            } else {
                return '';
            }
        } else {
            const renderedValue = row[columnDefinition.columnName];

            if (renderedValue) {
                return renderedValue;
            } else {
                return '';
            }
        }
    }
}
